/** @format */
import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'pdp-bv-shoppable-image',
	templateUrl: './bv-shoppable-image.component.html',
	styleUrl: './bv-shoppable-image.component.scss'
})
export class ShoppableImageComponent {}
